<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        :title="title"
        class="button shadow d-flex"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilSend" />
        </span>
        <span class="button__text">
            <slot>
                {{ $t("¡click me!") }}
            </slot>
        </span>
    </CButton>
</template>

<script>
import { cilPlus, cilSend } from "@coreui/icons";
export default {
    name: "ButtonAcction",
    icons: {
        cilPlus,
        cilSend
    },
    props: {
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "primary",
        },
        disabled: Boolean,
        type: String,
        title: String,
    },
};
</script>
